import config from 'configs/location';
import {
    history,
    objectToPathname,
    pathnameToObject,
    removeSegment,
} from 'utils/navigation';
import { trimBoth } from 'utils/formatters';

const location = (store) => (next) => (action) => {
    pushActions(currentLocationConfiguration(config), action, store);

    return next(action);
};
/**
 * Merge all the config separated by page matchers onto flat array config
 * @param  {Object}          config
 * @return {Array.<Object>}
 */
const currentLocationConfiguration = (config) => {
    const configuration = {};

    Object.keys(config).forEach((matcher) => {
        const match = history.location.pathname.match(matcher);
        if (match) {
            const configByParams = config[matcher];
            Object.keys(configByParams).forEach((paramName) => {
                configuration[paramName] = {
                    ...configByParams[paramName],
                    basePath: configByParams[paramName].basePath || match[0],
                };
            });
        }
    });

    return configuration;
};
/**
 * configuration:
 * The keys are the parameter key names (which are the same as appropriate URL keys)
 * And the values are the parameter descriptors including statePath, actions
 *
 * action: Redux action object
 *
 * @param {Array.<Object>} configuration
 * @param {Object}         action
 */
const pushActions = (configuration, action, store) => {
    Object.keys(configuration).forEach((paramName) => {
        const precond = configuration[paramName].precondition;

        if (
            precond &&
            !precond(
                store.getState(),
                convertPathnameToObject(configuration[paramName])
            )
        ) {
            return;
        }
        configuration[paramName].actions.forEach((a) => {
            if (action.type === a.type) {
                if (action.payload === undefined) {
                    action.payload = {};
                }

                const currentURLValues = convertPathnameToObject(
                    configuration[paramName]
                );

                const pushDescriptor = a.accessor
                    ? a.accessor(action, store.getState(), currentURLValues)
                    : action.payload;

                let fulfilled = true;
                let notFulfilledParams = [];
                const pathnameSegments = objectToPathname(
                    pushDescriptor,
                    configuration[paramName].pathnameSchema
                ).map((s) => {
                    // populating defaults from redux state
                    if (s[0] !== ':') {
                        return s;
                    }

                    const segmentName = s.slice(1);
                    let value = currentURLValues[segmentName];

                    if (!value) {
                        fulfilled = false;
                        notFulfilledParams.push(segmentName);
                    }

                    return value;
                });

                if (fulfilled) {
                    // console.log(
                    //     `${action.type} ->
                    //         before: ${window.location.pathname}
                    //         after:  ${createLocation(
                    //             configuration[paramName].basePath,
                    //             pathnameSegments
                    //         )}`
                    // );

                    history.push(
                        createLocation(
                            configuration[paramName].basePath,
                            pathnameSegments
                        )
                    );
                } else {
                    console.log(
                        `Not fulfilled: ${
                            action.type
                        } due to params: ${notFulfilledParams
                            .map((p) => `${p}:${currentURLValues[p]}`)
                            .join(', ')}`
                    );
                }
            }
        });
    });
};

const createLocation = (basePath, segments) => {
    basePath =
        basePath === '/' ? basePath : '/' + trimBoth(basePath, '/') + '/';
    const searchParams = new URLSearchParams(history.location.search);

    let res = `${basePath}${segments.join('/')}`;
    // keep search query parameters
    if (
        Array.from(new URLSearchParams(history.location.search).keys()).length >
        0
    ) {
        res = res + '?' + searchParams.toString();
    }
    return decodeURIComponent(res);
};

const convertPathnameToObject = (paramConfig) =>
    pathnameToObject(
        removeSegment(history.location.pathname, paramConfig.basePath),
        paramConfig.pathnameSchema
    );

export default location;
